import React from 'react'
import { connect } from 'react-redux';
import TransferCardHeader from './TransferCardHeader';
import KeyItem from './KeyItem';
import NewKeyItem from './NewKeyItem';
import actions from '../actions/index';
import { getHref } from '../helpers/AbloyKeyHelper';
import '../src/transferCard.scss';

const mapStateToProps = state => {
  return {
    givenKeys: state.givenKeys,
  }
};

class TransferInCard extends React.Component {
  constructor (props) {
    super(props);
  }

  /* computed */
  cardHeader() {
    const leaseId = this.props.transfer.new_lease_id;
    const href = getHref(leaseId);

    return (
      <div className="card-title">
        <i className='fa fa-arrow-right' />SISÄÄNMUUTTAJAT
        {href ? <a className="small-ghost-button" href={href}><i className="fa fa-key"></i>Avaimet</a> : null}
      </div>
    )
  }

  giveOutKeys(transfer) {
    if (!this.props.givenKeys || this.props.givenKeys.length === 0) {return null}

    const self = this;
    return (
      this.props.givenKeys.map((item) => {
        if (transfer.new_lease && transfer.new_lease.id) {
          return <KeyItem
            key={'key_stamp_in_' + item.id}
            abloyUpdatingMessageStatus={['HANDED_OUT']}
            abloyKeyOperations={[]}
            apartmentKeyOperations={['remove', 'give_to_customer']}
            possibleErrors={['is_busy', 'broken', 'lost']}
            greenStatus={'received'}
            item={item} lease={transfer.new_lease}
            inited={this.props.inited} />
        } else {
          return null
        }
      })
    )
  }

  render() {
    if (!this.props.transfer.new_lease) {
      return null;
    }
    const transfer = this.props.transfer;

    return (
      <div className="card-transfer">
        {/* header */}
        {this.cardHeader()}
        <TransferCardHeader customers={transfer.new_lease.primary_customers} date={transfer.new_lease.starts_on} leaseType='moving_in'/>
        <div className="card-keys load-keys">
        </div>
        {/* give out keys */}
        <div className="card-keys card-block">
          <p className="card-label">JAETUT AVAIMET</p>
          {this.giveOutKeys(transfer)}
        </div>
        <div className="card-keys card-block" style={{marginTop: '30px'}}>
          <p className="card-label">LUO UUSI AVAIN</p>
          <NewKeyItem lease={transfer.new_lease} />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(TransferInCard)
